import React from 'react'

import styled from 'styled-components'
import { color } from 'styles/colors'

type Props = {
  onClickFilterIcon: () => void
  anyFilterSelected: boolean
}

const FilterIcon = ({ onClickFilterIcon, anyFilterSelected }: Props) => {
  return (
    <S.FilterIcon
      className="icon-filter"
      onClick={onClickFilterIcon}
      anyFilterSelected={anyFilterSelected}
      role="button"
      aria-label="filters"
    />
  )
}

export default FilterIcon

const S = {
  FilterIcon: styled.div.withConfig({
    shouldForwardProp: (prop) => !['anyFilterSelected'].includes(prop)
  })<{ anyFilterSelected: boolean }>`
    display: flex;
    margin-left: auto;
    align-items: center;
    justify-content: center;
    font-size: 25px;
    color: ${color('filterIcon')};
    cursor: pointer;
    padding: 5px;

    ${({ anyFilterSelected }) => anyFilterSelected && `
      color: ${color('paneBackground')};
      background-color: ${color('filterIcon')};
    `}
  `
}
